
import { Folder } from "@/models/tasks/folder";
import { TaskService } from "@/services/task-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data() {
		return {
			folder: new Folder()
		};
	},
	props: {
		value: Boolean
	},
	watch: {
		value() {
			this.folder = new Folder();
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async submit() {
			this.validate();
			if (!this.isValid) return;
			let user = await TaskService.createFolder(this.folder);
			this.$emit("created", user);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
